import { ExpertReviewViewTypes } from './enums';
import { ImagePathWithRenditions } from './ImageTypes';

export type ExpertReviewState = {
  reviews?: Array<ExpertReview>;
};

export type ExpertInfo = {
  expertArea: Array<string>;
  firstName: string;
  image: ImagePathWithRenditions;
};

export type ExpertReview = {
  id: string;
  colorId: string;
  productCode: string;
  heading: string;
  title: string;
  expertInfo: ExpertInfo;
  view: ExpertReviewViewTypes;
  cons?: Array<string>;
  pros?: Array<string>;
  reviewText?: string;
  reviewImages?: Array<ImagePathWithRenditions>;
};
